export default "\r\n<button class=\"btn_try\" (click)=\"openDialog_receive_contact()\">\r\n  Nhận tư vấn miễn phí\r\n</button>";